import { Box } from "@mui/system";
import { ReactElement } from "react";
import AccountsDataGrid from "../hooks/accounts/accountsDataGrid";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function AccountsRoute(): ReactElement {
  return (
    <Box sx={{ p: 1, display: "flex", flex: 1 }}>
      <AccountsDataGrid />
    </Box>
  );
}
